import api from "../../../api";


export function manageContent(page, type="",key){
    return api.get(`cms/contents?type=${type}${key}&pageSize=10&pageNumber=${page}`);
}

export function allTag(){
    return api.get(`cms/tags/all`);
}

export function allSegment(){
    return api.get(`cms/segments/all`)
}

export function cmsContent(id){
    return api.get(`cms/contents/${id}`);
}

export function cmsEditContent(id, payload){
    return api.put(`cms/contents/${id}`, payload);
}

export function getPng(filePath){
    return api.get(`cms/mobile/read/content?key=${filePath}`)
}

export function imageUpload(payload){
    return api.post('contents/upload', payload);
}

export function deleteContent(id){
    return api.delete(`cms/contents/${id}`)
}

export function cmsContentTag(id){
    return api.get(`cms/tags/content/${id}`)
}

export function postTag(payload){
    return api.post(`cms/tags/content`, payload);
}

export function addContent(payload){
    return  api.post("cms/contents", payload) ;
}
